if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();

        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (cartNotification && this.openedBy) {
          cartNotification.setActiveElement(this.openedBy);
        }

        if (this.modalContent) {
          this.modalContent.innerHTML = '';
        }

        if (preventFocus) {
          this.openedBy = null;
        }

        super.hide();
      }

      show(opener) {
        if (!opener || !this.modalContent) return;

        const spinner = opener.querySelector('.loading-overlay__spinner');
        const productUrl = opener.getAttribute('data-product-url');

        if (!productUrl) return;

        opener.setAttribute('aria-disabled', 'true');
        opener.classList.add('loading');

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        fetch(productUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Erro ao carregar o produto: ${response.status}`);
            }

            return response.text();
          })
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );

            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-"]'
            );

            if (!this.productElement) {
              throw new Error(
                'A seção principal do produto não foi encontrada.'
              );
            }

            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.fixQuantityBreaks();

            const mediaGallery =
              this.productElement.querySelector('media-gallery');

            if (mediaGallery) {
              mediaGallery.dataset.disablePrepend = 'false';
              mediaGallery.removeAttribute('data-filtering-option');

              mediaGallery
                .querySelectorAll(
                  '.product__media-item.hidden, .thumbnail-list__item.hidden'
                )
                .forEach((item) => {
                  item.classList.remove('hidden');
                });
            }

            this.productElement
              .querySelectorAll('variant-selects, variant-radios')
              .forEach((variantPicker) => {
                variantPicker.dataset.hasFiltering = 'false';
              });

            this.setInnerHTML(
              this.modalContent,
              this.productElement.innerHTML
            );

            /*
             * Transforma o quick add em uma janela compacta:
             * título, preço, variantes e botão.
             */
            this.prepareVelaroQuickAdd();
            this.fixDesktopVariantAvailability();
            this.setupVelaroPriceDisplay();

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) {
              window.ProductModel.loadShopifyXR();
            }

            this.removeGalleryListSemantic();
            this.preventVariantURLSwitching();

            super.show(opener);
            this.fixDesktopVariantAvailability();
            this.setupVelaroPriceDisplay();
          })
          .catch((error) => {
            console.error('Velaro Quick Add:', error);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');

            if (spinner) {
              spinner.classList.add('hidden');
            }
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        /*
         * Scripts inseridos com innerHTML não executam automaticamente.
         * Este trecho recria cada script para permitir sua execução.
         */
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');

          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });

          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML)
          );

          oldScriptTag.parentNode.replaceChild(
            newScriptTag,
            oldScriptTag
          );
        });
      }

      prepareVelaroQuickAdd() {
        if (!this.modalContent) return;

        /*
         * Identificação específica para o CSS do modal Velaro.
         */
        this.classList.add('velaro-quick-add-modal');

        const modalContent = this.modalContent;

        /*
         * Remove completamente a galeria e a coluna de imagens.
         */
        modalContent
          .querySelectorAll(
            [
              'media-gallery',
              '.product__media-wrapper',
              '.product__media-list',
              '.product__media',
              '.product-media-container',
              '.product__media-gallery',
              '.thumbnail-slider',
              '.thumbnail-list',
              'product-modal',
              'slider-component[id*="Gallery"]'
            ].join(',')
          )
          .forEach((element) => element.remove());

        /*
         * Remove blocos desnecessários da página do produto.
         */
        modalContent
          .querySelectorAll(
            [
              'pickup-availability',
              'sticky-atc',
              'quantity-breaks',
              'quantity-input',
              'shopify-payment-terms',
              '.shopify-payment-button',
              '.product__description',
              '.product__accordion',
              '.accordion',
              '.product__tax',
              '.product__inventory',
              '.product__sku',
              '.product__view-details',
              '.product-popup-modal__opener',
              '.product__share',
              '.share-button',
              '.icon-with-text',
              '.product__custom-liquid',
              '.product-form__quantity',
              '.payment-icons',
              '.payment-methods',
              '.product__payment-icons',
              '.trust-badges',
              '.trust-badge',
              '.product-trust',
              '.product__trust',
              '.stock-warning',
              '.stock-alert',
              '.inventory-notice',
              '.demand-bar',
              '.product-demand',
              '.urgency-message',
              '.product-benefits',
              '.product__benefits',
              '.guarantee-block',
              '.shipping-block',
              '.delivery-block',
              '.review-widget',
              '.rating-wrapper',
              '.product-rating',
              '.jdgm-widget',
              '.jdgm-preview-badge',
              '.loox-rating',
              '.badge-offer',
              '.offer-badge',
              '.product__text',
              '.complementary-products',
              'product-recommendations',
              '.social-sharing',
              '.product__pickup-availabilities',
              '.product__installments',
              '.product__policies',
              '.product__shipping',
              '.product__delivery',
              '.product__usp',
              '.product__icons',
              '.product__features',
              '.product__metafields',
              '.product__collapsible-content',
              '.product__tabs'
            ].join(',')
          )
          .forEach((element) => element.remove());

        /*
         * Remove blocos do editor da Shopify que não contêm
         * nenhum elemento essencial do quick add.
         */
        const infoContainer =
          modalContent.querySelector('.product__info-container') ||
          modalContent.querySelector('.product__info-wrapper');

        if (infoContainer) {
          Array.from(infoContainer.children).forEach((element) => {
            const containsEssentialElement =
              element.matches('.product__title') ||
              element.matches('.price') ||
              element.matches('[id^="price-"]') ||
              element.matches('[id^="Price-"]') ||
              element.matches('variant-selects') ||
              element.matches('variant-radios') ||
              element.matches('product-form') ||
              element.matches('.product-form') ||
              element.matches('script') ||
              element.matches('noscript') ||
              element.querySelector('.product__title') ||
              element.querySelector('.price') ||
              element.querySelector('[id^="price-"]') ||
              element.querySelector('[id^="Price-"]') ||
              element.querySelector('variant-selects') ||
              element.querySelector('variant-radios') ||
              element.querySelector('product-form') ||
              element.querySelector('.product-form');

            if (!containsEssentialElement) {
              element.remove();
            }
          });
        }

        /*
         * Remove colunas vazias que possam continuar no grid.
         */
        const product = modalContent.querySelector('.product');

        if (product) {
          Array.from(product.children).forEach((element) => {
            const isInformationColumn =
              element.matches('.product__info-wrapper') ||
              element.matches('.product__info-container') ||
              element.querySelector('.product__info-container') ||
              element.querySelector('.product__info-wrapper') ||
              element.querySelector('variant-selects') ||
              element.querySelector('variant-radios') ||
              element.querySelector('product-form');

            if (!isInformationColumn) {
              element.remove();
            }
          });
        }

        /*
         * Remove quantidade caso ela esteja dentro do formulário.
         */
        modalContent
          .querySelectorAll(
            [
              '.product-form__quantity',
              '.quantity',
              'quantity-input',
              '[name="quantity"]'
            ].join(',')
          )
          .forEach((element) => {
            const quantityWrapper =
              element.closest('.product-form__quantity') ||
              element.closest('.quantity');

            if (quantityWrapper) {
              quantityWrapper.remove();
            } else {
              element.remove();
            }
          });

        /*
         * Ajusta o texto do botão principal.
         */
        const addButton =
          modalContent.querySelector('button[name="add"]') ||
          modalContent.querySelector('.product-form__submit');

        if (addButton && !addButton.disabled) {
          const buttonLabel =
            addButton.querySelector('.main-atc__label__text') ||
            addButton.querySelector('span:not(.loading-overlay__spinner)');

          if (buttonLabel) {
            buttonLabel.textContent = 'ADD TO CART';
          } else {
            addButton.textContent = 'ADD TO CART';
          }
        }

        /*
         * Injeta apenas uma vez o CSS completo do modal.
         */
        this.injectVelaroQuickAddStyles();
      }

      injectVelaroQuickAddStyles() {
        let style = document.getElementById(
          'velaro-quick-add-styles'
        );

        if (!style) {
          style = document.createElement('style');
          style.id = 'velaro-quick-add-styles';
          document.head.appendChild(style);
        }

        style.textContent = `
          quick-add-modal.velaro-quick-add-modal {
            position: fixed !important;
            inset: 0 !important;
            z-index: 999999 !important;

            display: flex !important;
            align-items: center !important;
            justify-content: center !important;

            width: 100vw !important;
            height: 100vh !important;
            padding: 24px !important;

            box-sizing: border-box !important;
          }

          quick-add-modal.velaro-quick-add-modal::before {
            content: "";
            position: fixed;
            inset: 0;
            z-index: -1;

            background: rgba(20, 24, 31, 0.52);
            backdrop-filter: blur(2px);
            -webkit-backdrop-filter: blur(2px);
          }

          .velaro-quick-add-modal .quick-add-modal__content {
            position: relative !important;

            top: auto !important;
            right: auto !important;
            bottom: auto !important;
            left: auto !important;

            width: min(520px, calc(100vw - 48px)) !important;
            min-width: 0 !important;
            max-width: 520px !important;

            height: auto !important;
            min-height: 0 !important;
            max-height: calc(100vh - 48px) !important;

            margin: 0 !important;
            padding: 0 !important;

            overflow-x: hidden !important;
            overflow-y: auto !important;

            transform: none !important;
            translate: none !important;

            border: 0 !important;
            border-radius: 16px !important;

            background: #ffffff !important;
            box-shadow: 0 24px 80px rgba(15, 23, 42, 0.26) !important;

            box-sizing: border-box !important;
          }

          .velaro-quick-add-modal .quick-add-modal__content-info {
            display: block !important;

            width: 100% !important;
            height: auto !important;
            min-height: 0 !important;
            max-width: none !important;

            margin: 0 !important;
            padding: 0 !important;

            overflow: visible !important;
            box-sizing: border-box !important;
          }

          .velaro-quick-add-modal .product {
            display: block !important;

            width: 100% !important;
            min-width: 0 !important;
            max-width: none !important;
            min-height: 0 !important;

            margin: 0 !important;
            padding: 38px 32px 30px !important;

            grid-template-columns: 1fr !important;
            grid-template-rows: auto !important;
            gap: 0 !important;

            background: #ffffff !important;
            box-sizing: border-box !important;
          }

          .velaro-quick-add-modal .product__info-wrapper,
          .velaro-quick-add-modal .product__info-container {
            display: block !important;

            position: static !important;

            width: 100% !important;
            min-width: 0 !important;
            max-width: none !important;

            margin: 0 !important;
            padding: 0 !important;

            transform: none !important;
            box-sizing: border-box !important;
          }

          .velaro-quick-add-modal .product__info-container > * {
            max-width: 100% !important;
          }

          .velaro-quick-add-modal .product__title {
            width: auto !important;
            max-width: calc(100% - 50px) !important;

            margin: 0 50px 8px 0 !important;
            padding: 0 !important;
          }

          .velaro-quick-add-modal .product__title h1,
          .velaro-quick-add-modal .product__title h2,
          .velaro-quick-add-modal .product__title {
            color: #202631 !important;

            font-size: 24px !important;
            line-height: 1.2 !important;
            font-weight: 650 !important;
            letter-spacing: -0.02em !important;
          }

          .velaro-quick-add-modal [id^="price-"],
          .velaro-quick-add-modal [id^="Price-"],
          .velaro-quick-add-modal .price {
            margin: 0 0 24px !important;
            padding: 0 !important;
          }

          .velaro-quick-add-modal .price,
          .velaro-quick-add-modal .price-item {
            color: #202631 !important;

            font-size: 21px !important;
            line-height: 1.2 !important;
            font-weight: 650 !important;
          }

          /*
           * Evita preço duplicado: a área promocional aparece
           * somente quando o produto realmente está em oferta.
           */
          .velaro-quick-add-modal .price:not(.price--on-sale) .price__sale {
            display: none !important;
          }

          .velaro-quick-add-modal .price:not(.price--on-sale) .price__regular {
            display: block !important;
          }

          .velaro-quick-add-modal .price.price--on-sale .price__regular {
            display: none !important;
          }

          .velaro-quick-add-modal .price.price--on-sale .price__sale {
            display: flex !important;
            align-items: center !important;
            flex-wrap: wrap !important;
            gap: 8px !important;
          }

          .velaro-quick-add-modal .price.price--on-sale .price-item--regular {
            color: #737985 !important;
            font-size: 14px !important;
            line-height: 1.2 !important;
            font-weight: 400 !important;
            text-decoration: line-through !important;
            text-decoration-thickness: 1px !important;
          }

          .velaro-quick-add-modal .price.price--on-sale .price-item--sale {
            color: #202631 !important;
            font-size: 21px !important;
            line-height: 1.2 !important;
            font-weight: 700 !important;
          }

          .velaro-quick-add-modal .price__badge-sale,
          .velaro-quick-add-modal .badge.price__badge-sale {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            margin: 0 !important;
            padding: 5px 9px !important;
            border: 0 !important;
            border-radius: 999px !important;
            background: #202631 !important;
            color: #ffffff !important;
            font-size: 10px !important;
            line-height: 1 !important;
            font-weight: 700 !important;
            letter-spacing: 0.05em !important;
            text-transform: uppercase !important;
          }

          .velaro-quick-add-modal variant-selects,
          .velaro-quick-add-modal variant-radios,
          .velaro-quick-add-modal card-variant-selects {
            display: block !important;

            width: 100% !important;
            min-width: 0 !important;
            max-width: 100% !important;

            margin: 0 0 22px !important;
            padding: 0 !important;

            overflow: visible !important;
          }

          .velaro-quick-add-modal .product-form__input {
            display: block !important;

            width: 100% !important;
            min-width: 0 !important;
            max-width: none !important;

            margin: 0 0 20px !important;
            padding: 0 !important;

            border: 0 !important;
          }

          .velaro-quick-add-modal .product-form__input legend,
          .velaro-quick-add-modal .form__label {
            display: block !important;

            margin: 0 0 12px !important;
            padding: 0 !important;

            color: #202631 !important;

            font-size: 14px !important;
            line-height: 1.4 !important;
            font-weight: 600 !important;
          }

          .velaro-quick-add-modal .product-form__input input[type="radio"] + label {
            box-sizing: border-box !important;
          }

          .velaro-quick-add-modal .color-swatch,
          .velaro-quick-add-modal .product-form__input label {
            max-width: 100% !important;
          }

          .velaro-quick-add-modal .product-form {
            display: block !important;

            width: 100% !important;
            min-width: 0 !important;
            max-width: none !important;

            margin: 0 !important;
            padding: 0 !important;
          }

          .velaro-quick-add-modal .product-form form {
            width: 100% !important;
            max-width: none !important;
            margin: 0 !important;
          }

          .velaro-quick-add-modal .product-form__buttons {
            display: block !important;

            width: 100% !important;
            min-width: 0 !important;
            max-width: none !important;

            margin: 8px 0 0 !important;
            padding: 0 !important;
          }

          .velaro-quick-add-modal .product-form__submit,
          .velaro-quick-add-modal button[name="add"] {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;

            position: relative !important;

            width: 100% !important;
            min-width: 0 !important;
            max-width: none !important;
            min-height: 54px !important;

            margin: 0 !important;
            padding: 14px 20px !important;

            border: 0 !important;
            border-radius: 4px !important;

            background: #3f444e !important;
            color: #ffffff !important;

            font-size: 13px !important;
            line-height: 1.2 !important;
            font-weight: 700 !important;
            letter-spacing: 0.06em !important;
            text-transform: uppercase !important;

            box-shadow: none !important;
            transform: none !important;

            cursor: pointer !important;
          }

          .velaro-quick-add-modal .product-form__submit::before,
          .velaro-quick-add-modal .product-form__submit::after,
          .velaro-quick-add-modal button[name="add"]::before,
          .velaro-quick-add-modal button[name="add"]::after {
            display: none !important;
            content: none !important;
          }

          .velaro-quick-add-modal .product-form__submit:hover,
          .velaro-quick-add-modal .product-form__submit:focus,
          .velaro-quick-add-modal button[name="add"]:hover,
          .velaro-quick-add-modal button[name="add"]:focus {
            border: 0 !important;
            background: #3f444e !important;
            color: #ffffff !important;
            box-shadow: none !important;
            transform: none !important;
          }

          .velaro-quick-add-modal .product-form__submit[disabled],
          .velaro-quick-add-modal button[name="add"][disabled] {
            background: #a5a8ae !important;
            color: #ffffff !important;
            opacity: 1 !important;
            cursor: not-allowed !important;
          }

          .velaro-quick-add-modal .quick-add-modal__toggle {
            position: absolute !important;

            top: 14px !important;
            right: 14px !important;
            bottom: auto !important;
            left: auto !important;

            display: flex !important;
            align-items: center !important;
            justify-content: center !important;

            width: 38px !important;
            height: 38px !important;
            min-width: 38px !important;
            min-height: 38px !important;

            margin: 0 !important;
            padding: 10px !important;

            border: 1px solid #e2e4e8 !important;
            border-radius: 50% !important;

            background: #ffffff !important;
            color: #3f444e !important;

            box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08) !important;
            transform: none !important;

            z-index: 20 !important;
          }

          .velaro-quick-add-modal .quick-add-modal__toggle:hover,
          .velaro-quick-add-modal .quick-add-modal__toggle:focus {
            border-color: #e2e4e8 !important;
            background: #ffffff !important;
            color: #3f444e !important;
            box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08) !important;
            transform: none !important;
          }

          .velaro-quick-add-modal .quick-add-modal__toggle svg {
            display: block !important;
            width: 17px !important;
            height: 17px !important;
          }

          .velaro-quick-add-modal .quick-add-modal__toggle svg path {
            stroke: currentColor !important;
          }

          /* Preço e selos montados pelo JavaScript do Quick Add */
          .velaro-quick-add-modal .velaro-original-price-hidden {
            display: none !important;
          }

          .velaro-quick-add-modal .velaro-custom-price-container {
            display: block !important;
            width: 100% !important;
            margin: 0 0 24px !important;
            padding: 0 !important;
          }

          .velaro-quick-add-modal .velaro-price-block {
            display: block !important;
            width: 100% !important;
            margin: 0 0 22px !important;
            padding: 0 !important;
          }

          .velaro-quick-add-modal .velaro-price-values {
            display: flex !important;
            align-items: baseline !important;
            flex-wrap: wrap !important;
            gap: 9px !important;
          }

          .velaro-quick-add-modal .velaro-compare-price {
            color: #7b818c !important;
            font-size: 15px !important;
            line-height: 1.2 !important;
            font-weight: 500 !important;
            text-decoration: line-through !important;
            text-decoration-thickness: 1px !important;
          }

          .velaro-quick-add-modal .velaro-current-price {
            color: #202631 !important;
            font-size: 23px !important;
            line-height: 1.15 !important;
            font-weight: 750 !important;
            letter-spacing: -0.02em !important;
          }

          .velaro-quick-add-modal .velaro-price-badges {
            display: flex !important;
            align-items: center !important;
            flex-wrap: wrap !important;
            gap: 7px !important;
            margin-top: 10px !important;
          }

          .velaro-quick-add-modal .velaro-offer-badge,
          .velaro-quick-add-modal .velaro-buy-two-badge {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            min-height: 26px !important;
            padding: 6px 10px !important;
            border-radius: 999px !important;
            font-size: 10px !important;
            line-height: 1 !important;
            font-weight: 750 !important;
            letter-spacing: 0.055em !important;
            text-transform: uppercase !important;
            white-space: nowrap !important;
          }

          .velaro-quick-add-modal .velaro-offer-badge {
            border: 1px solid #202631 !important;
            background: #202631 !important;
            color: #ffffff !important;
          }

          .velaro-quick-add-modal .velaro-buy-two-badge {
            border: 1px solid #d8b35d !important;
            background: #fff8e7 !important;
            color: #6e5114 !important;
          }

          /* =========================================================
             VELARO — QUICK ADD RESPONSIVO EM TODOS OS MOBILES
             ========================================================= */

          @media screen and (max-width: 749px) {
            quick-add-modal.velaro-quick-add-modal {
              position: fixed !important;
              inset: 0 !important;
              z-index: 999999 !important;

              display: flex !important;
              align-items: flex-end !important;
              justify-content: center !important;

              width: 100% !important;
              max-width: 100% !important;

              height: 100vh !important;
              height: 100svh !important;
              height: 100dvh !important;

              margin: 0 !important;
              padding: 0 !important;

              overflow: hidden !important;
              box-sizing: border-box !important;
            }

            quick-add-modal.velaro-quick-add-modal::before {
              position: fixed !important;
              inset: 0 !important;

              background: rgba(20, 24, 31, 0.54) !important;
              backdrop-filter: blur(2px) !important;
              -webkit-backdrop-filter: blur(2px) !important;
            }

            .velaro-quick-add-modal .quick-add-modal__content {
              position: relative !important;

              top: auto !important;
              right: auto !important;
              bottom: 0 !important;
              left: auto !important;

              display: block !important;

              width: 100% !important;
              min-width: 0 !important;
              max-width: 100% !important;

              height: auto !important;
              min-height: 0 !important;

              max-height: 78vh !important;
              max-height: 78svh !important;
              max-height: 78dvh !important;

              margin: 0 !important;
              padding: 0 !important;

              overflow-x: hidden !important;
              overflow-y: auto !important;

              overscroll-behavior: contain !important;
              -webkit-overflow-scrolling: touch !important;

              transform: none !important;
              translate: none !important;

              border: 0 !important;
              border-radius: 22px 22px 0 0 !important;

              background: #ffffff !important;
              box-shadow:
                0 -12px 40px rgba(15, 23, 42, 0.18),
                0 -2px 10px rgba(15, 23, 42, 0.06) !important;

              box-sizing: border-box !important;
            }

            .velaro-quick-add-modal .quick-add-modal__content-info {
              display: block !important;

              width: 100% !important;
              min-width: 0 !important;
              max-width: 100% !important;

              height: auto !important;
              min-height: 0 !important;

              margin: 0 !important;
              padding: 0 !important;

              overflow: visible !important;
              box-sizing: border-box !important;
            }

            .velaro-quick-add-modal .product {
              display: block !important;

              width: 100% !important;
              min-width: 0 !important;
              max-width: 100% !important;

              height: auto !important;
              min-height: 0 !important;

              margin: 0 !important;

              padding:
                30px
                20px
                calc(22px + env(safe-area-inset-bottom))
                20px !important;

              overflow: visible !important;

              background: #ffffff !important;
              box-sizing: border-box !important;
            }

            .velaro-quick-add-modal .product__info-wrapper,
            .velaro-quick-add-modal .product__info-container {
              position: static !important;
              display: block !important;

              width: 100% !important;
              min-width: 0 !important;
              max-width: 100% !important;

              height: auto !important;
              min-height: 0 !important;

              margin: 0 !important;
              padding: 0 !important;

              overflow: visible !important;
              transform: none !important;
              box-sizing: border-box !important;
            }

            .velaro-quick-add-modal .product__title {
              width: auto !important;
              max-width: calc(100% - 52px) !important;

              margin: 0 52px 7px 0 !important;
              padding: 0 !important;
            }

            .velaro-quick-add-modal .product__title,
            .velaro-quick-add-modal .product__title h1,
            .velaro-quick-add-modal .product__title h2 {
              color: #202631 !important;

              font-size: clamp(20px, 5.2vw, 23px) !important;
              line-height: 1.2 !important;
              font-weight: 650 !important;
              letter-spacing: -0.02em !important;

              overflow-wrap: anywhere !important;
            }

            .velaro-quick-add-modal [id^="price-"],
            .velaro-quick-add-modal [id^="Price-"],
            .velaro-quick-add-modal .price {
              margin: 0 0 20px !important;
              padding: 0 !important;
            }

            .velaro-quick-add-modal .price {
              font-size: clamp(19px, 5vw, 22px) !important;
              line-height: 1.2 !important;
            }

            .velaro-quick-add-modal
              .price.price--on-sale
              .price-item--regular {
              font-size: 14px !important;
            }

            .velaro-quick-add-modal
              .price.price--on-sale
              .price-item--sale,
            .velaro-quick-add-modal
              .price:not(.price--on-sale)
              .price-item--regular {
              font-size: clamp(19px, 5vw, 22px) !important;
              line-height: 1.2 !important;
            }

            .velaro-quick-add-modal variant-selects,
            .velaro-quick-add-modal variant-radios,
            .velaro-quick-add-modal card-variant-selects {
              display: block !important;

              width: 100% !important;
              min-width: 0 !important;
              max-width: 100% !important;

              margin: 0 0 18px !important;
              padding: 0 !important;

              overflow: visible !important;
              box-sizing: border-box !important;
            }

            .velaro-quick-add-modal .product-form__input {
              display: flex !important;
              flex-wrap: wrap !important;
              align-items: flex-start !important;

              width: 100% !important;
              min-width: 0 !important;
              max-width: 100% !important;

              margin: 0 0 18px !important;
              padding: 0 !important;

              gap: 10px !important;

              border: 0 !important;
              overflow: visible !important;
              box-sizing: border-box !important;
            }

            .velaro-quick-add-modal .product-form__input legend,
            .velaro-quick-add-modal .product-form__input .form__label,
            .velaro-quick-add-modal .form__label {
              flex: 0 0 100% !important;

              display: block !important;
              width: 100% !important;

              margin: 0 0 3px !important;
              padding: 0 !important;

              color: #202631 !important;

              font-size: 14px !important;
              line-height: 1.4 !important;
              font-weight: 600 !important;
            }

            .velaro-quick-add-modal
              .product-form__input
              input[type="radio"] + label,
            .velaro-quick-add-modal .color-swatch {
              flex: 0 0 auto !important;
              max-width: calc(25% - 8px) !important;

              margin: 0 !important;
              box-sizing: border-box !important;
            }

            /*
             * Mantém o óculos inteiro visível nas miniaturas.
             */
            .velaro-quick-add-modal
              .product-form__input
              input[type="radio"] + label,
            .velaro-quick-add-modal .color-swatch {
              background-size: contain !important;
              background-position: center !important;
              background-repeat: no-repeat !important;
            }

            .velaro-quick-add-modal
              .product-form__input
              input[type="radio"] + label img,
            .velaro-quick-add-modal .color-swatch img {
              display: block !important;

              width: 100% !important;
              max-width: 100% !important;
              height: 100% !important;
              max-height: 100% !important;

              object-fit: contain !important;
              object-position: center !important;
            }

            .velaro-quick-add-modal .product-form,
            .velaro-quick-add-modal .product-form form,
            .velaro-quick-add-modal .product-form__buttons {
              display: block !important;

              width: 100% !important;
              min-width: 0 !important;
              max-width: 100% !important;

              margin-left: 0 !important;
              margin-right: 0 !important;

              padding-left: 0 !important;
              padding-right: 0 !important;

              box-sizing: border-box !important;
            }

            .velaro-quick-add-modal .product-form__buttons {
              margin-top: 16px !important;
            }

            .velaro-quick-add-modal .product-form__submit,
            .velaro-quick-add-modal button[name="add"] {
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;

              width: 100% !important;
              min-width: 0 !important;
              max-width: 100% !important;

              min-height: 54px !important;

              margin: 0 !important;
              padding: 14px 18px !important;

              border: 0 !important;
              border-radius: 6px !important;

              background: #3f444e !important;
              color: #ffffff !important;

              font-size: 13px !important;
              line-height: 1.2 !important;
              font-weight: 700 !important;
              letter-spacing: 0.06em !important;

              box-sizing: border-box !important;
            }

            .velaro-quick-add-modal .quick-add-modal__toggle {
              position: absolute !important;

              top: 12px !important;
              right: 12px !important;
              bottom: auto !important;
              left: auto !important;

              display: flex !important;
              align-items: center !important;
              justify-content: center !important;

              width: 40px !important;
              height: 40px !important;
              min-width: 40px !important;
              min-height: 40px !important;

              margin: 0 !important;
              padding: 10px !important;

              border: 1px solid #e2e4e8 !important;
              border-radius: 50% !important;

              background: #ffffff !important;
              color: #3f444e !important;

              box-shadow: 0 4px 16px rgba(0, 0, 0, 0.09) !important;

              z-index: 30 !important;
              box-sizing: border-box !important;
            }
          }

          @media screen and (max-width: 390px) {
            .velaro-quick-add-modal .product {
              padding-left: 16px !important;
              padding-right: 16px !important;
            }

            .velaro-quick-add-modal .product-form__input {
              gap: 8px !important;
            }

            .velaro-quick-add-modal
              .product-form__input
              input[type="radio"] + label,
            .velaro-quick-add-modal .color-swatch {
              max-width: calc(25% - 6px) !important;
            }
          }

          @media screen and (max-width: 749px) and (max-height: 700px) {
            .velaro-quick-add-modal .quick-add-modal__content {
              max-height: 84vh !important;
              max-height: 84svh !important;
              max-height: 84dvh !important;
            }

            .velaro-quick-add-modal .product {
              padding-top: 25px !important;
              padding-bottom:
                calc(18px + env(safe-area-inset-bottom)) !important;
            }

            .velaro-quick-add-modal [id^="price-"],
            .velaro-quick-add-modal [id^="Price-"],
            .velaro-quick-add-modal .price {
              margin-bottom: 16px !important;
            }

            .velaro-quick-add-modal .product-form__input {
              margin-bottom: 14px !important;
            }
          }

          @media screen and (min-width: 600px) and (max-width: 749px) {
            .velaro-quick-add-modal .product {
              padding-left: 28px !important;
              padding-right: 28px !important;
            }

            .velaro-quick-add-modal .quick-add-modal__content {
              max-height: 74vh !important;
              max-height: 74svh !important;
              max-height: 74dvh !important;
            }
          }
        `;
      }

      setupVelaroPriceDisplay() {
        if (!this.modalContent) return;

        const variantPicker = this.modalContent.querySelector(
          'variant-radios, variant-selects'
        );

        if (!variantPicker) return;

        let variants = [];

        try {
          if (Array.isArray(variantPicker.variantData)) {
            variants = variantPicker.variantData;
          } else {
            const variantScript = variantPicker.querySelector(
              'script[type="application/json"]'
            );

            if (variantScript) {
              variants = JSON.parse(variantScript.textContent || '[]');
            }
          }
        } catch (error) {
          console.warn(
            'Velaro Quick Add: unable to load prices.',
            error
          );
        }

        if (!Array.isArray(variants) || !variants.length) return;

        const getSelectedOptions = () => {
          const groups = Array.from(
            variantPicker.querySelectorAll('fieldset, .product-form__input')
          ).filter((group) =>
            group.querySelector('input[type="radio"], select')
          );

          return groups.map((group) => {
            const checked = group.querySelector('input[type="radio"]:checked');
            const select = group.querySelector('select');

            if (checked) return checked.value;
            if (select) return select.value;
            return null;
          });
        };

        const findSelectedVariant = () => {
          const formVariantInput = this.modalContent.querySelector(
            'form[action*="/cart/add"] input[name="id"]'
          );

          if (formVariantInput?.value) {
            const variantById = variants.find(
              (variant) => String(variant.id) === String(formVariantInput.value)
            );

            if (variantById) return variantById;
          }

          const selectedOptions = getSelectedOptions();

          return (
            variants.find((variant) =>
              selectedOptions.every(
                (value, index) =>
                  value == null || variant.options?.[index] === value
              )
            ) || variants[0]
          );
        };

        const getCurrency = () =>
          window.Shopify?.currency?.active ||
          document.documentElement.dataset.currency ||
          'EUR';

        const formatMoney = (amountInCents) => {
          const amount = Number(amountInCents || 0) / 100;

          try {
            return new Intl.NumberFormat('es-ES', {
              style: 'currency',
              currency: getCurrency(),
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(amount);
          } catch (error) {
            return `€${amount.toFixed(2).replace('.', ',')}`;
          }
        };

        const getOriginalPriceRoots = () =>
          Array.from(
            this.modalContent.querySelectorAll(
              '[id^="price-"], [id^="Price-"], .price'
            )
          ).filter(
            (element) =>
              !element.classList.contains('velaro-custom-price-container') &&
              !element.closest('.velaro-custom-price-container')
          );

        const hideOriginalPrice = () => {
          getOriginalPriceRoots().forEach((element) => {
            element.style.setProperty('display', 'none', 'important');
            element.setAttribute('aria-hidden', 'true');
            element.classList.add('velaro-original-price-hidden');
          });
        };

        const getCustomPriceContainer = () => {
          let container = this.modalContent.querySelector(
            '.velaro-custom-price-container'
          );

          if (container) return container;

          container = document.createElement('div');
          container.className =
            'velaro-custom-price-container velaro-price-block';
          container.setAttribute('aria-live', 'polite');

          const title = this.modalContent.querySelector('.product__title');
          const infoContainer =
            this.modalContent.querySelector('.product__info-container') ||
            this.modalContent.querySelector('.product__info-wrapper');

          if (title?.parentNode) {
            title.insertAdjacentElement('afterend', container);
          } else if (infoContainer) {
            infoContainer.prepend(container);
          }

          return container;
        };

        const getComparisonPrice = (variant, price) => {
          const variantCompareAt = Number(variant.compare_at_price || 0);

          if (variantCompareAt > price) return variantCompareAt;

          const productCompareAt = Math.max(
            ...variants.map((item) => Number(item.compare_at_price || 0)),
            0
          );

          if (productCompareAt > price) return productCompareAt;

          /*
           * A oferta principal é BUY 2, PAY FOR 1.
           * Quando o tema não fornece compare_at_price, o comparativo
           * representa o valor normal de duas unidades.
           */
          return price * 2;
        };

        let renderingPrice = false;

        const renderPrice = () => {
          if (renderingPrice) return;
          renderingPrice = true;

          try {
            hideOriginalPrice();

            const variant = findSelectedVariant();
            const container = getCustomPriceContainer();

            if (!variant || !container) return;

            const price = Number(variant.price || 0);
            const compareAtPrice = getComparisonPrice(variant, price);
            const discountPercentage =
              compareAtPrice > price
                ? Math.round(
                    ((compareAtPrice - price) / compareAtPrice) * 100
                  )
                : 0;

            container.innerHTML = `
              <div class="velaro-price-values">
                <span class="velaro-compare-price">${formatMoney(
                  compareAtPrice
                )}</span>
                <span class="velaro-current-price">${formatMoney(price)}</span>
              </div>

              <div class="velaro-price-badges">
                <span class="velaro-offer-badge">OFFER$${
                  discountPercentage ? ` -${discountPercentage}%` : ''
                }</span>
                <span class="velaro-buy-two-badge">BUY 2, PAY FOR 1</span>
              </div>
            `;

            const formVariantInput = this.modalContent.querySelector(
              'form[action*="/cart/add"] input[name="id"]'
            );

            if (formVariantInput && variant.id) {
              formVariantInput.value = variant.id;
              formVariantInput.dispatchEvent(
                new Event('change', { bubbles: false })
              );
            }
          } finally {
            renderingPrice = false;
          }
        };

        const scheduleRender = () => {
          renderPrice();
          window.requestAnimationFrame(renderPrice);
          window.setTimeout(renderPrice, 60);
          window.setTimeout(renderPrice, 180);
          window.setTimeout(renderPrice, 400);
        };

        if (!variantPicker.dataset.velaroPriceBound) {
          variantPicker.addEventListener('change', scheduleRender, true);
          variantPicker.dataset.velaroPriceBound = 'true';
        }

        if (!this._velaroPriceObserver) {
          this._velaroPriceObserver = new MutationObserver((mutations) => {
            const shouldRefresh = mutations.some((mutation) => {
              const target =
                mutation.target.nodeType === Node.ELEMENT_NODE
                  ? mutation.target
                  : mutation.target.parentElement;

              return (
                target &&
                !target.closest('.velaro-custom-price-container') &&
                (target.matches?.(
                  '[id^="price-"], [id^="Price-"], .price, .price__badges'
                ) ||
                  target.closest?.(
                    '[id^="price-"], [id^="Price-"], .price, .price__badges'
                  ))
              );
            });

            if (shouldRefresh) scheduleRender();
          });

          this._velaroPriceObserver.observe(this.modalContent, {
            childList: true,
            subtree: true,
            characterData: true
          });
        }

        scheduleRender();
      }

      fixDesktopVariantAvailability() {
        if (!this.modalContent || window.matchMedia('(max-width: 749px)').matches) {
          return;
        }

        const variantPickers = this.modalContent.querySelectorAll(
          'variant-radios, variant-selects'
        );

        variantPickers.forEach((variantPicker) => {
          let variants = [];

          try {
            if (Array.isArray(variantPicker.variantData)) {
              variants = variantPicker.variantData;
            } else {
              const variantScript = variantPicker.querySelector(
                'script[type="application/json"]'
              );

              if (variantScript) {
                variants = JSON.parse(variantScript.textContent || '[]');
              }
            }
          } catch (error) {
            console.warn('Velaro Quick Add: variantes não puderam ser lidas.', error);
          }

          if (!Array.isArray(variants) || !variants.length) return;

          const optionGroups = Array.from(
            variantPicker.querySelectorAll('fieldset, .product-form__input')
          ).filter((group) =>
            group.querySelector('input[type="radio"], select')
          );

          const getSelectedOptions = () =>
            optionGroups.map((group) => {
              const checkedInput = group.querySelector(
                'input[type="radio"]:checked'
              );
              const select = group.querySelector('select');

              if (checkedInput) return checkedInput.value;
              if (select) return select.value;
              return null;
            });

          const updateAvailability = () => {
            const selectedOptions = getSelectedOptions();

            optionGroups.forEach((group, groupIndex) => {
              const radioInputs = group.querySelectorAll(
                'input[type="radio"]'
              );
              const select = group.querySelector('select');

              radioInputs.forEach((input) => {
                const candidateOptions = [...selectedOptions];
                candidateOptions[groupIndex] = input.value;

                const isAvailable = variants.some((variant) => {
                  if (!variant || !variant.available) return false;

                  return candidateOptions.every((value, optionIndex) =>
                    value == null || variant.options?.[optionIndex] === value
                  );
                });

                input.disabled = !isAvailable;
                input.removeAttribute('aria-disabled');

                const label = variantPicker.querySelector(
                  `label[for="${CSS.escape(input.id)}"]`
                );

                if (label) {
                  label.classList.toggle('disabled', !isAvailable);
                  label.classList.toggle('sold-out', !isAvailable);
                  label.classList.toggle('unavailable', !isAvailable);
                  label.setAttribute('aria-disabled', String(!isAvailable));
                }
              });

              if (select) {
                Array.from(select.options).forEach((option) => {
                  const candidateOptions = [...selectedOptions];
                  candidateOptions[groupIndex] = option.value;

                  option.disabled = !variants.some((variant) => {
                    if (!variant || !variant.available) return false;

                    return candidateOptions.every((value, optionIndex) =>
                      value == null || variant.options?.[optionIndex] === value
                    );
                  });
                });
              }
            });
          };

          if (!variantPicker.dataset.velaroAvailabilityBound) {
            variantPicker.addEventListener('change', () => {
              window.requestAnimationFrame(updateAvailability);
            });

            variantPicker.dataset.velaroAvailabilityBound = 'true';
          }

          updateAvailability();
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector(
          'variant-radios, variant-selects'
        );

        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        if (!this.productElement) return;

        const pickupAvailability =
          this.productElement.querySelector('pickup-availability');

        if (pickupAvailability) {
          pickupAvailability.remove();
        }

        const productModal =
          this.productElement.querySelector('product-modal');

        if (productModal) {
          productModal.remove();
        }

        const stickyAtc =
          this.productElement.querySelector('sticky-atc');

        if (stickyAtc) {
          stickyAtc.remove();
        }

        const modalDialogs =
          this.productElement.querySelectorAll('modal-dialog');

        modalDialogs.forEach((modal) => {
          modal.remove();
        });
      }

      fixQuantityBreaks() {
        if (!this.productElement) return;

        const quantityBreaks =
          this.productElement.querySelector('quantity-breaks');

        if (!quantityBreaks) return;

        quantityBreaks.querySelectorAll('input').forEach((input) => {
          input.id += '-QuickAdd';
        });

        quantityBreaks.querySelectorAll('label').forEach((label) => {
          const oldValue = label.getAttribute('for');

          if (oldValue) {
            label.setAttribute('for', `${oldValue}-QuickAdd`);
          }
        });
      }

      preventDuplicatedIDs() {
        if (!this.productElement) return;

        const sectionId = this.productElement.dataset.section;

        if (!sectionId) return;

        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
          );

        this.productElement
          .querySelectorAll(
            'variant-selects, variant-radios, product-info'
          )
          .forEach((element) => {
            element.dataset.originalSection = sectionId;
          });
      }

      removeGalleryListSemantic() {
        if (!this.modalContent) return;

        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]'
        );

        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');

        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((item) => {
            item.setAttribute('role', 'presentation');
          });
      }

      updateImageSizes() {
        if (!this.modalContent) return;

        const product = this.modalContent.querySelector('.product');

        if (!product) return;

        const desktopColumns =
          product.classList.contains('product--columns');

        if (!desktopColumns) return;

        const mediaImages =
          product.querySelectorAll('.product__media img');

        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, ' +
          '(min-width: 750px) calc((100vw - 11.5rem) / 2), ' +
          'calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace(
            '715px',
            '605px'
          );
        } else if (
          product.classList.contains('product--small')
        ) {
          mediaImageSizes = mediaImageSizes.replace(
            '715px',
            '495px'
          );
        }

        mediaImages.forEach((image) => {
          image.setAttribute('sizes', mediaImageSizes);
        });
      }
    }
  );
}